/* global d3 */
class EventGraph {
  constructor(manager) {
    this.manager = manager;
    this.hideToolTipInterval = false;
    this.clearHideIntervalOnEvent();
  }

  render(url, svg, x, height) {
    this.getData(url, (data) => {
      this.usedColors = [];
      var g = svg.selectAll("rect").data(data).enter().append("g");
      var self = this;
      g.attr("class", "report-group").attr("transform", "translate(" + 0 + "," + (height + 15) + ")");

      g.append("rect")
        .attr("x", function (d) {
          return x(d.start_time);
        })
        .attr("y", 0)
        .attr("width", function (d) {
          return x(d.end_time) - x(d.start_time);
        })
        .attr("height", 35)
        .style("fill", (d) => {
          return this.colorUsed(d.avatar_color);
        });

      g.append("svg:image")
        .style("display", function (d) {
          if (x(d.end_time) - x(d.start_time) < 60) {
            return "none";
          }
        })
        .attr("x", function (d) {
          return x(d.start_time) + 5;
        })
        .attr("y", function (d) {
          return 7;
        })
        .attr("width", 20)
        .attr("height", 20)
        .attr("xlink:href", function (d) {
          return d.avatar_url;
        });

      g.append("text")
        .style("display", function (d) {
          if (x(d.end_time) - x(d.start_time) < 30) {
            return "none";
          }
        })
        .attr("x", function (d) {
          if (x(d.end_time) - x(d.start_time) < 60) {
            return x(d.start_time) + 5;
          }

          return x(d.start_time) + 30;
        })
        .attr("y", function (d) {
          return 21;
        })
        .attr("font-size", 12)
        .text(function (d) {
          return d.name;
        });

      // The rect acts as a hitbox for each of the values
      g.append("rect")
        .attr("x", function (d) {
          return x(d.start_time);
        })
        .attr("y", 0)
        .attr("width", function (d) {
          return x(d.end_time) - x(d.start_time);
        })
        .attr("height", 35)
        .style("opacity", 0)
        .on("mouseover", function (d) {
          clearInterval(self.hideToolTipInterval);
          self.manager.tooltip.show(this, d.tooltip, "event", d3.mouse(this)[0]);
        })
        .on("mouseout", function (d) {
          clearInterval(self.hideToolTipInterval);
          self.hideToolTipInterval = setInterval(function () {
            if (self.manager.tooltip.shouldHideTooltip() && jQuery(g.node()).filter(":hover").length === 0) {
              self.manager.tooltip.hide();
              clearInterval(self.hideToolTipInterval);
            }
          }, 450);
        });
    });
  }

  clearHideIntervalOnEvent() {
    jQuery(this.manager.tooltip.tooltip.node()).on("tooltip:show", (e, graphType) => {
      if (graphType === "metric") {
        clearInterval(this.hideToolTipInterval);
        this.hideToolTipInterval = false;
      }
    });
  }

  colorUsed(color) {
    var returnColor = color;
    if (this.usedColors[this.usedColors.length - 1] == color) {
      returnColor = this.getContrastColor(color);
    }
    this.usedColors.push(color);
    return returnColor;
  }

  getContrastColor(color) {
    var percent = 0.0;
    while (percent <= 0.15 && percent >= -0.1) {
      percent = Math.random() * (0.3 - -0.4) + -0.4;
    }
    return this.shadeBlend(percent, color);
  }

  // Programmaticly Lighten or Darken hex or RGB colors
  // From: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
  shadeBlend(p, c0, c1) {
    var n = p < 0 ? p * -1 : p,
      u = Math.round,
      w = parseInt;
    if (c0.length > 7) {
      var f = c0.split(","),
        R = w(f[0].slice(4)),
        G = w(f[1]),
        B = w(f[2]);
      var t = c1;
      if (!t) {
        t = p < 0 ? "rgb(0,0,0)" : "rgb(255,255,255)";
      }
      t = t.split(",");
      return (
        "rgb(" +
        (u((w(t[0].slice(4)) - R) * n) + R) +
        "," +
        (u((w(t[1]) - G) * n) + G) +
        "," +
        (u((w(t[2]) - B) * n) + B) +
        ")"
      );
    } else {
      var f = w(c0.slice(1), 16),
        R1 = f >> 16,
        G1 = (f >> 8) & 0x00ff,
        B1 = f & 0x0000ff;
      var t = c1;
      if (!t) {
        t = p < 0 ? "#000000" : "#FFFFFF";
      }
      t = w(t.slice(1), 16);
      return (
        "#" +
        (
          0x1000000 +
          (u(((t >> 16) - R1) * n) + R1) * 0x10000 +
          (u((((t >> 8) & 0x00ff) - G1) * n) + G1) * 0x100 +
          (u(((t & 0x0000ff) - B1) * n) + B1)
        )
          .toString(16)
          .slice(1)
      );
    }
  }

  getData(url, callback) {
    return d3.csv(url, function (error, data) {
      if (error) {
        throw error;
      }
      var parseDate = d3.timeParse("%Y-%m-%d %H:%M:%S");

      // format the data
      data.forEach(function (d) {
        d.start_time = parseDate(d.start_time);
        d.end_time = parseDate(d.end_time);
      });

      callback(data);
    });
  }
}

window.EventGraph = EventGraph;
